angular.module("PlatformStatisticsApp").controller("PlatformStatisticsController", ["$scope", "$rootScope", "PlatformInviteStatisticsFactory",
    function ($scope, $rootScope, PlatformInviteStatisticsFactory) {
        PlatformInviteStatisticsFactory.query(function (result) {
            $scope.platform = result;
        });
    }]);